import { GridType } from '@data-access/grid-views';
import { SubmissionGridTypes, SubmissionsGrid } from '../types';
import { InjectionToken } from '@angular/core';
import {
  DEFAULT_BASE_GRID_PROPS,
  DEFAULT_CHECKBOX_PROPS,
} from '@data-access/shared';
import { WcgChipType } from '@wcg/frontend-framework';
import { ERM_ICONS_ENUM } from '@erm/cluster';
import { PINNED_CHIP_LABEL_MAPPER } from '@data-access/dash-board';

export const submissionListInitialState: SubmissionsGrid = {
  data: [],
  currentUrl: '',
  submissionListScope: null as SubmissionGridTypes | null,
  gridType: 'workspace-list' as GridType,
  views: [],
  isUpdatingSMEQC: false,
  quickFilterCounts: null,
  quickFilter: 'all',
  ...DEFAULT_CHECKBOX_PROPS,
  ...DEFAULT_BASE_GRID_PROPS,
};

export const SUBMISSION_LIST_GRID_STATE = new InjectionToken<SubmissionsGrid>(
  'Submission List grid state',
  {
    factory: () => ({ ...submissionListInitialState }),
  },
);

/** Row icon mapping for pinned submission card content rows */
export const PINNED_SUBMISSION_ICON_MAPPER = new Map<string, string>([
  ['wcg_tracking_id', ERM_ICONS_ENUM.VPN_KEY],
  ['sponsor_protocol_id', ERM_ICONS_ENUM.ASSIGNMENT_IND],
  ['sponsor', ERM_ICONS_ENUM.WORK_OUTLINE],
  ['priority', ERM_ICONS_ENUM.PRIORITY_HIGH],
  ['pi', ERM_ICONS_ENUM.VACCINES],
  ['sites', ERM_ICONS_ENUM.PERSON],
]);

/** Chip type mapper extended with submission notification statuses */
export const PINNED_SUBMISSION_NOTIFICATION_CHIP_MAPPER = new Map<
  string,
  WcgChipType
>([
  ['to-do', WcgChipType.CRITICAL],
  ['on_hold', WcgChipType.WARNING],
]);

/** Chip label mapper extended with submission notification labels */
export const PINNED_SUBMISSION_NOTIFICATION_LABEL_MAPPER = new Map<
  string,
  string
>([...PINNED_CHIP_LABEL_MAPPER, ['on_hold', 'On Hold']]);

/** Backend chips persisted in a saved view's `notification` marker. */
export const PERSISTED_QUICK_FILTER_KEYS: readonly string[] = [
  'needs_your_action',
  'in_wcg_hands',
  'completed',
];
